import { ApiError } from '@/components/Functional/lib/request'

/**
 * TanStack Query の `retry` オプションに渡す判定関数。
 *
 * 4xx はリトライしても結果が変わらないため即座に諦める。
 * 既定（3回・指数バックオフ）のままだと 404 の画面が数秒間ローディング表示のまま残るため、
 * NotFound を扱う画面では必ずこれを指定すること。
 * 5xx・ネットワークエラーは一時的な障害の可能性があるため最大2回まで再試行する。
 */
export function shouldRetryApiError(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
  return failureCount < 2
}
